var _rect, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5440_74488",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5440_74488)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 22V20.5H3.025C2.075 19.3333 1.33333 18.029 0.8 16.587C0.266667 15.1457 0 13.6167 0 12C0 10.3833 0.266667 8.854 0.8 7.412C1.33333 5.97067 2.075 4.66667 3.025 3.5H1V2H6V7H4.5V4.1C3.56667 5.15 2.83333 6.35 2.3 7.7C1.76667 9.05 1.5 10.4833 1.5 12C1.5 13.5167 1.76667 14.946 2.3 16.288C2.83333 17.6293 3.56667 18.8333 4.5 19.9V17H6V22H1ZM15.275 21.675L9.175 19.15L9.575 18.05C9.625 17.9 9.71667 17.7667 9.85 17.65C9.98333 17.5333 10.1417 17.4583 10.325 17.425L13.575 16.775L9.225 6.95C9.05833 6.56667 9.046 6.18333 9.188 5.8C9.32933 5.41667 9.59167 5.14167 9.975 4.975C10.3583 4.80833 10.7417 4.8 11.125 4.95C11.5083 5.1 11.7833 5.36667 11.95 5.75L14.4 11.225L15.225 10.85C15.3583 10.8 15.5083 10.754 15.675 10.712C15.8417 10.6707 15.9917 10.6583 16.125 10.675L20.7 10.875C21.1333 10.9083 21.5167 11.0583 21.85 11.325C22.1833 11.5917 22.4083 11.925 22.525 12.325L23.775 16.65C23.9083 17.1333 23.875 17.6 23.675 18.05C23.475 18.5 23.1417 18.825 22.675 19.025L17.025 21.55C16.7417 21.6833 16.4417 21.7627 16.125 21.788C15.8083 21.8127 15.525 21.775 15.275 21.675Z",
    fill: "#494C4F"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVertical);
export default __webpack_public_path__ + "static/media/icon_vertical.d7507034f1b253cf649898e30592c432.svg";
export { ForwardRef as ReactComponent };